export const styles = {
  root: 'tw-w-full tw-h-screen',
};
